
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '@core/services/storage.service';
import { environment } from '@env/environment';
import { AuthService } from '@services/auth.service';
import { UsersService } from '@services/users.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private usersService: UsersService,
        private storageService: StorageService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const user = this.usersService.userValue;
        const sessionKey = (this.storageService.get('SessionKey') || null);

        if (user && sessionKey) {

            // check if route is restricted by role
            if (route.data.licenceType && !route.data.licenceType.includes(user.LicenseType) || route.data.roles && !route.data.roles.includes(user.RoleType)) {
                // role not authorised so redirect to home page
                // this.authService.logout();
                window.location.href = environment.tempUrl;
                return false;
            }

            // logged in so return true
            return true;
        } else {
            // not logged in so redirect to login page with the return url
            this.authService.logout(state.url);
            return false;
        }
    }
}
